exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-inline-x-number{display:inline-block}", ""]);

// exports
